var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.564 22.8792C23.8575 17.0341 27.3796 13.5519 32.6207 13.0959V9.86246C27.3796 9.40646 23.8575 5.96572 23.564 0.120605L19.6647 0.949698C19.8743 3.06389 20.629 4.92935 21.8869 6.62899C23.1867 8.28718 24.6542 9.365 26.3314 9.86246H0V13.0959H26.3314C24.6542 13.5934 23.1867 14.6712 21.8869 16.3708C20.629 18.0705 19.8743 19.9359 19.6647 22.0087L23.564 22.8792Z"}));
}

Arrow.defaultProps = {"width":"33","height":"23","viewBox":"0 0 33 23"};

module.exports = Arrow;

Arrow.default = Arrow;
